import axios from 'axios';
import Swal from 'sweetalert2';
import { getCountryNameByCode } from '@SHARED/js/helpers/misc';
import FormHelperMixin from '@SHARED/js/Vue/mixins/FormHelperMixin';
import store from '../../store/store';
import template from './CustomerDeliveryFormComponent.html';

export default {
  template,

  mixins: [FormHelperMixin],

  props: {
    defaultFormData: {
      type: Object,
    },
    isEditable: {
      type: Boolean,
    },
  },

  data() {
    return {
      formData: {
        delivery_address_name:
          this.defaultFormData.delivery_address_name || this.defaultFormData.invoice_address_name || store.authUserFullname,
        delivery_address1:
          this.defaultFormData.delivery_address1 || this.defaultFormData.invoice_address1 || '',
        delivery_postal_code:
          this.defaultFormData.delivery_postal_code || this.defaultFormData.invoice_postal_code || '',
        delivery_post_office: // aka city
          this.defaultFormData.delivery_post_office || this.defaultFormData.invoice_post_office || '',
        delivery_country: '578',
      },
      sharedState: store, // Do not modify this directly – this is only for convenience in templates.
      editable: false,
      isLoading: false,
      isDirty: false,
    };
  },

  created() {
    if (
      !this.isReady() ||
      // If any of the these default properties were not set, we need the user to confirm suggested input before proceeding
      _.isEmpty(this.defaultFormData.delivery_address_name) ||
      _.isEmpty(this.defaultFormData.delivery_address1) ||
      _.isEmpty(this.defaultFormData.delivery_postal_code) ||
      _.isEmpty(this.defaultFormData.delivery_post_office)
    ) {
      if (this.isEditable) {
        this.editable = true;
      }
      this.isDirty = true;
    }
  },

  watch: {
    editable(val) {
      this.$emit('editable-changed', val);
    },
    formData: {
      handler() {
        this.isDirty = true;
      },
      deep: true,
    },
  },

  methods: {
    submitForm() {
      // Prevent double click
      if (!this.isLoading) {
        this.updateDeliveryData();
      }
    },

    getCountryNameByCode,

    // Component API
    isReady() {
      if (
        this.isLoading ||
        this.isDirty ||
        _.isEmpty(this.formData.delivery_address_name) ||
        _.isEmpty(this.formData.delivery_address1) ||
        _.isEmpty(this.formData.delivery_postal_code) ||
        _.isEmpty(this.formData.delivery_post_office)
      ) {
        return false;
      }

      return true;
    },

    // API

    updateDeliveryData() {
      // Simply skip API call if not dirty, unless not ready.
      if (!this.isDirty && this.isReady()) {
        this.editable = false;

        return;
      }

      this.isLoading = true;
      this.clearErrors();

      this.$emit('updating-delivery-data', this.formData);

      axios.patch('/api/v1/customer/updateDeliveryData', this.formData)
        .then((response) => {
          this.editable = false;
          this.isDirty = false;

          store.info.authUser.customer = Object.assign(
            {},
            store.info.authUser.customer,
            response.data,
          );

          this.$emit('update-delivery-data-success', response.data);
        })
        .catch((error) => {
          if (typeof error.response.data.errors !== 'undefined') {
            this.errors = error.response.data.errors;
            this.addAttrError('message', 'Kunne ikke lagre informasjon. Sjekk at feltene er riktig.');
          } else {
            Swal.fire(
              'Noe gikk galt',
              'Vennligst prøv igjen. Om problemet vedvarer, ring Kraftex (<a href="tel:69252530">69 25 25 30</a>).<br>' +
              'Feil utenom våre åpningstider melder du <a href="/kontakt-oss" target="_blank">her</a>, så tar vi kontakt med deg.',
              'error',
            );

            window.bugsnagClient && window.bugsnagClient.notify(error);
            throw new Error(error);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
